function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgLinkedinSquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.111 12.556c0 .855-.544 1.555-1.555 1.555-.934 0-1.556-.7-1.556-1.478 0-.855.622-1.633 1.556-1.633.933 0 1.555.7 1.555 1.556Zm0 2.333H11V25h3.111V14.889Zm7.492.004c-1.621 0-2.544.949-2.93 1.581h-.077l-.154-1.344h-2.775c0 .87.077 1.893.077 3.08V25h3.084v-5.605c0-.316 0-.553.077-.79.232-.554.618-1.265 1.467-1.265 1.08 0 1.544.948 1.544 2.21v5.446H25v-5.842c0-2.921-1.467-4.265-3.393-4.265l-.004.004Z",
  fill: props.color || 'currentColor'
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 34,
  height: 34,
  rx: 3,
  stroke: props.color || 'currentColor',
  strokeWidth: 2
}));
export default SvgLinkedinSquare;